document.addEventListener('DOMContentLoaded', function() {
  document.addEventListener('click', function(e) {
    const summary = e.target.closest('summary');
    if (!summary) return;
    const clickedDetails = summary.closest('details');
    if (!clickedDetails) return;
    document.querySelectorAll('details').forEach(function(detail) {
      if (detail !== clickedDetails && detail.open) {
        detail.open = false;
      }
    });
  });
});
document.addEventListener('DOMContentLoaded', function() {
  document.addEventListener('click', function(e) {
    const summary = e.target.closest('summary');
    if (!summary) return;
    const clickedDetails = summary.closest('details');
    if (!clickedDetails) return;
    document.querySelectorAll('details').forEach(function(detail) {
      if (detail !== clickedDetails && detail.open) {
        detail.open = false;
      }
    });
  });
});

document.addEventListener('DOMContentLoaded', function() {
  if (window.location.search.includes('contact_posted=true')) {
  var form = document.querySelector('form[id^="ContactForm"]');
    if (form) {
      form.innerHTML = '<div style="text-align:center; padding: 2rem 0;"><p style="font-size: 18px; font-weight: 500;">Thank you for your message!</p><p style="color: #666; margin-top: 8px;">We\'ll get back to you within 1–2 business days.</p></div>';
    }
  }
});